import AlertComponent, { AlertType } from '@spa/components/alert/alert.component';
import React, { Fragment, ReactElement } from 'react';
import { FormAction } from '@spa/lib/actions/newsletter/FormAction';
import { NamespacedIntl } from '@spa/lib/i18n/common/NamespacedIntl';
import NewsletterSendUpdateOrUnsubscribeComponent from '@spa/components/forms/newsletter-send-update-or-unsubscribe-form/newsletter-send-update-or-unsubscribe.component';
import { User } from 'next-auth';
import styles from './newsletter-unsubscribe.component.module.scss';
import useNamespacedIntl from '@spa/lib/i18n/client/hooks/useNamespacedIntl';
import { useSession } from 'next-auth/react';

export interface Props {
  readonly unsubscribeSucceeded: boolean | null;
  readonly hideComponent?: boolean;
}

function NewsletterUnsubscribeComponent({
  unsubscribeSucceeded,
  hideComponent = false
}: Props): ReactElement {
  const { data, status } = useSession();
  const userData: User | undefined = data?.user;
  const { formatMessage }: NamespacedIntl = useNamespacedIntl('newsletter-unsubscribe');

  return (
    <>
      {!hideComponent && (
        <div className={styles['newsletter-unsubscribe']}>
          <h2>{formatMessage('title')}</h2>
          {unsubscribeSucceeded === null ? (
            <Fragment>
              <span>{formatMessage('subtitle')}</span>
              <div className={styles['newsletter-unsubscribe__form']}>
                <NewsletterSendUpdateOrUnsubscribeComponent
                  action={FormAction.UNSUBSCRIBE}
                  initialEmail={userData?.email ?? ''}
                  isSessionLoading={status === 'loading'}
                />
              </div>
            </Fragment>
          ) : (
            <AlertComponent
              alertType={unsubscribeSucceeded ? AlertType.SUCCESS : AlertType.ERROR}
              content={formatMessage(unsubscribeSucceeded ? 'success' : 'error')}
            />
          )}
        </div>
      )}
    </>
  );
}

export default NewsletterUnsubscribeComponent;
